import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { usePlanSettingsScenePreview } from '@editorHooks'
import { planSettingsValidationSchema } from '../../planSettingsValidationSchema'

/**
 * Shows the form's current values in the scene while it is open (see
 * `usePlanSettingsScenePreview`), before they are saved. Invalid values (e.g. an empty scale while
 * typing) aren't previewed; the saved settings show meanwhile.
 */
const PlanSettingsScenePreview = (): null => {
  const values = useWatch() as PdfPlanSettings

  const planSettings = useMemo(
    () =>
      planSettingsValidationSchema.isValidSync(values)
        ? (planSettingsValidationSchema.cast(values) as PdfPlanSettings)
        : undefined,
    [values],
  )

  usePlanSettingsScenePreview(planSettings)

  return null
}

export default PlanSettingsScenePreview
